import axios from 'axios';
import config from './config';

const baseURL = process.env.VUE_APP_API_URL;

// Create an Axios instance with baseURL and default headers
export const HTTP = axios.create({
  baseURL,
  headers: {
    'Content-Type': 'application/json',
    ...(config.authHeader ? { Authorization: config.authHeader } : {})
  },
  timeout: 20000 // 15 seconds timeout for all requests
});

// Add request interceptor for authentication if needed
HTTP.interceptors.request.use(
  (config) => {
    if (!config.isConfigured && process.env.NODE_ENV === 'development') {
      console.warn('API is not properly configured with authentication credentials');
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Add response interceptor for error handling
HTTP.interceptors.response.use(
  (response) => response,
  (error) => {
    // Handle common errors here
    if (error.response) {
      // Server responded with error status
      if (process.env.NODE_ENV === 'development') {
        console.error('API Error:', error.response.status, error.response.data);
      }
      if (error.response.status === 401) {
        if (process.env.NODE_ENV === 'development') {
          console.error('Authentication failed. Please check your credentials.');
        }
      }
    } else if (error.request) {
      // Request made but no response received
      if (process.env.NODE_ENV === 'development') {
        console.error('Network Error:', error.request);
      }
    } else {
      if (process.env.NODE_ENV === 'development') {
        console.error('Error:', error.message);
      }
    }
    return Promise.reject(error);
  }
);